<template>

  <form @submit.prevent="userSubmit">

    <div class="form-control" :class="{invalid: idError}" style="display: none">
      <label for="id">Id пользователя в БД (не трогать)</label>
      <input type="text" id="id" v-model="id" @blur="idBlur" disabled="true">
      <small v-if="idError">{{idError}}</small>
    </div>

    <div class="form-control" :class="{invalid: nError}">
      <label for="name">ФИО</label>
      <input type="text" id="name" v-model="name" @blur="nBlur" autocomplete="off">
      <small v-if="nError">{{nError}}</small>
    </div>

    <div class="form-control" :class="{invalid: pError}">
      <label for="phone">Телефон</label>
      <input type="text" id="phone" v-model="phone" @blur="pBlur" autocomplete="off">
      <small v-if="pError">{{pError}}</small>
    </div>

    <div class="form-control" :class="{invalid: cError}">
      <label for="contract">Номер договора</label>
      <input type="text" id="contract" v-model="contract" @blur="cBlur" autocomplete="off">
      <small v-if="cError">{{cError}}</small>
    </div>

    <div class="form-control" :class="{invalid: eError}">
      <label for="email">Email</label>
      <input type="email" id="email" v-model="email" @blur="eBlur" autocomplete="off">
      <small v-if="eError">{{eError}}</small>
    </div>

    <div class="form-control" :class="{invalid: aError}">
      <label for="address">Адрес</label>
      <input type="text" id="address" v-model="address" @blur="aBlur" autocomplete="off">
      <small v-if="aError">{{aError}}</small>
    </div>

    <div class="form-control" :class="{invalid: eqError}">
      <label for="equipment">Оборудование</label>
      <input type="text" id="equipment" v-model="equipment" @blur="eqBlur" autocomplete="off">
      <small v-if="eqError">{{eqError}}</small>
    </div>

    <div class="form-control" :class="{invalid: vError}">
      <label for="validity">Срок действия договора</label>
      <input type="date" id="validity" v-model="validity" @blur="vBlur" autocomplete="off">
      <small v-if="vError">{{vError}}</small>
    </div>

    <div class="form-control">
      <label for="trest">Трест</label>
      <select id="trest" v-model="trest" size="15">
        <optgroup label="МОСКВА">
          <option value="МОСКВА-москва">Москва</option>
        </optgroup>
        <optgroup label="ПОДОЛЬСК">
          <option value="ПОДОЛЬСК-подольск">Подольск</option>
          <option value="ПОДОЛЬСК-ступино">Ступино</option>
          <option value="ПОДОЛЬСК-серебряные пруды">Серебряные пруды</option>
          <option value="ПОДОЛЬСК-михнево">Михнево</option>
          <option value="ПОДОЛЬСК-зарайск">Зарайск</option>
          <option value="ПОДОЛЬСК-кашира">Кашира</option>
          <option value="ПОДОЛЬСК-видное">Видное</option>
          <option value="ПОДОЛЬСК-столбовая">Столбовая</option>
          <option value="ПОДОЛЬСК-чехов">Чехов</option>
          <option value="ПОДОЛЬСК-Домодедово">Домодедово</option>
          <option value="ПОДОЛЬСК-серпухов">Серпухов</option>
          <option value="ПОДОЛЬСК-климовск">Климовск</option>
        </optgroup>
        <optgroup label="ОДИНЦОВО">
          <option value="ОДИНЦОВО-одинцово">Одинцово</option>
          <option value="ОДИНЦОВО-апрелевка">Апрелевка</option>
          <option value="ОДИНЦОВО-щербинка">Щербинка</option>
          <option value="ОДИНЦОВО-вороново">Вороново</option>
          <option value="ОДИНЦОВО-троицк">Троицк</option>
          <option value="ОДИНЦОВО-верея">Верея</option>
          <option value="ОДИНЦОВО-наро-фоминск">Наро-Фоминск</option>
          <option value="ОДИНЦОВО-голицино">Голицино</option>
          <option value="ОДИНЦОВО-можайск">Можайск</option>
          <option value="ОДИНЦОВО-руза">Руза</option>
          <option value="ОДИНЦОВО-барвиха">Барвиха</option>
          <option value="ОДИНЦОВО-кубинка">Кубинка</option>
        </optgroup>
        <optgroup label="НОГИНСК">
          <option value="НОГИНСК-ногинск">Ногинск</option>
          <option value="НОГИНСК-балашиха">Балашиха</option>
          <option value="НОГИНСК-фрязино">Фрязино</option>
          <option value="НОГИНСК-лосино-петровский">Лосино-Петровский</option>
          <option value="НОГИНСК-щёлково">Щёлково</option>
          <option value="НОГИНСК-рошаль">Рошаль</option>
          <option value="НОГИНСК-салтыковка">Салтыковка</option>
          <option value="НОГИНСК-шатура">Шатура</option>
          <option value="НОГИНСК-куровское">Куровское</option>
          <option value="НОГИНСК-ликино-дулево">Ликино-Дулево</option>
          <option value="НОГИНСК-орехово-зуево">Орехово-Зуево</option>
          <option value="НОГИНСК-электроугли">Электроугли</option>
          <option value="НОГИНСК-павлово-посад">Павлово-Посад</option>
          <option value="НОГИНСК-электросталь">Электросталь</option>
        </optgroup>
        <optgroup label="МЫТИЩИ">
          <option value="МЫТИЩИ-мытищи">Мытищи</option>
          <option value="МЫТИЩИ-катуар">Катуар</option>
          <option value="МЫТИЩИ-дмитров">Дмитров</option>
          <option value="МЫТИЩИ-дубна">Дубна</option>
          <option value="МЫТИЩИ-талдом">Талдом</option>
          <option value="МЫТИЩИ-братовщина">Братовщина</option>
          <option value="МЫТИЩИ-сергиев-посад">Сергиев-Посад</option>
          <option value="МЫТИЩИ-пушкино">Пушкино</option>
          <option value="МЫТИЩИ-хотьково">Хотьково</option>
          <option value="МЫТИЩИ-королёв">Королёв</option>
        </optgroup>
        <optgroup label="КРАСНОГОРСК">
          <option value="КРАСНОГОРСК-красногорск">Красногорск</option>
          <option value="КРАСНОГОРСК-химки">Химки</option>
          <option value="КРАСНОГОРСК-сходня">Сходня</option>
          <option value="КРАСНОГОРСК-долгопрудный">Долгопрудный</option>
          <option value="КРАСНОГОРСК-солнечногорск">Солнечногорск</option>
          <option value="КРАСНОГОРСК-клин">Клин</option>
          <option value="КРАСНОГОРСК-шаховская">Шаховская</option>
          <option value="КРАСНОГОРСК-лотошино">Лотошино</option>
          <option value="КРАСНОГОРСК-волоколамск">Волоколамс</option>
          <option value="КРАСНОГОРСК-дедовск">Дедовск</option>
          <option value="КРАСНОГОРСК-истра">Истра</option>
          <option value="КРАСНОГОРСК-нахабино">Нахабино</option>
        </optgroup>
        <optgroup label="КОЛОМНА">
          <option value="КОЛОМНА-коломна">Коломна</option>
          <option value="КОЛОМНА-люберцы">Люберцы</option>
          <option value="КОЛОМНА-малаховка">Малаховка</option>
          <option value="КОЛОМНА-озеры">Озеры</option>
          <option value="КОЛОМНА-быково">Быково</option>
          <option value="КОЛОМНА-бронницы">Бронницы</option>
          <option value="КОЛОМНА-электроизолятор">Электроизолятор</option>
          <option value="КОЛОМНА-жуковский">Жуковский</option>
          <option value="КОЛОМНА-раменское">Раменское</option>
          <option value="КОЛОМНА-егорьевск">Егорьевск</option>
          <option value="КОЛОМНА-луховицы">Луховицы</option>
          <option value="КОЛОМНА-воскресенск">Воскресенск</option>
        </optgroup>
      </select>
    </div>
    <button class="btn primary" :disabled="isSubmitting" @click="update">Отправить</button>
  </form>
</template>

<script>


import {useUserForm} from "@/components/use/user-form";
import {useRouter} from 'vue-router'
import {useStore} from "vuex";
import {inject} from 'vue'

export default {
  emits: ['created'],

  setup(_, {emit}) {
    const store = useStore()
    const router = useRouter()

    const fio = inject('fio1')
    const userId = inject('id1')
    const mobile = inject('mobile1')
    const docs = inject('docs1')
    const mail = inject('mail1')
    const equip = inject('equip1')
    const date = inject('date1')
    const location = inject('location1')
    const home = inject('home1')

    const submit = async values => {
      await store.dispatch('request/updateUser', values)
      emit('created')
      await router.push('/admin')
      await store.dispatch('request/getAuthUsers')
    }

    return {
      ...useUserForm(submit, fio, mobile, docs, mail, userId, equip, date, location, home),

    }
  }

}
</script>

<style scoped>

</style>